import {Component} from '@angular/core';
import {ApiInterfaceFormComponent} from "../../../../../forms/api-interface-form/api-interface-form.component";
import {ModalComponent} from "../../../../../utils/modal/modal.component";
import {FormGroup} from "@angular/forms";
import {MdbModalRef} from "mdb-angular-ui-kit/modal";
import {HttpErrorsService} from "../../../../../../services/utils/http-errors.service";
import {finalize} from "rxjs";
import {ApiInterfaceModel} from "../../../../../../models/resources/api-interface.model";
import {ApiInterfaceCustomerService} from "../../../../../../services/resources/api-interface-customer.service";
import {ApiInterfaceCustomerModel} from "../../../../../../models/resources/api-interface-customer.model";
import {
  ApiInterfaceCustomerFormComponent
} from "../../../../../forms/api-interface-customer-form/api-interface-customer-form.component";

@Component({
  selector: 'app-new-api-interface-customer-modal',
  imports: [
    ApiInterfaceFormComponent,
    ModalComponent,
    ApiInterfaceCustomerFormComponent
  ],
  templateUrl: './new-api-interface-customer-modal.component.html',
  styleUrl: './new-api-interface-customer-modal.component.scss',
})
export class NewApiInterfaceCustomerModalComponent {
  loading: boolean = false;
  formGroup: FormGroup | undefined;

  apiInterface: ApiInterfaceModel | undefined;

  constructor(
    private modalRef: MdbModalRef<NewApiInterfaceCustomerModalComponent>,
    private httpErrorService: HttpErrorsService,
    private apiInterfaceCustomerService: ApiInterfaceCustomerService
  ) {
  }

  submit() {
    this.formGroup!.markAllAsTouched();

    if (this.formGroup!.invalid) return;

    this.loading = true;

    let resource = {
      apiInterfaceId: this.apiInterface?.id,
      customerId: this.formGroup!.get('customer')?.value?.id
    };

    this.apiInterfaceCustomerService
      .create(resource)
      .pipe(finalize(() => (this.loading = false)))
      .subscribe({
        next: (apiInterfaceCustomer: ApiInterfaceCustomerModel) => {
          this.modalRef.close(apiInterfaceCustomer);
        },
        error: (e) => {
          this.httpErrorService.handleError(e);
        },
      });
  }
}
